// import React from "react";

// const WhatWeBelieve = () => {
//   return (
//     <section className="about_us_Clarity_feature">
//       <div className="about_us_Clarity_feature__header">
//         <span className="about_us_Clarity_feature__badge">Our Philosophy</span>
//         <h2 className="about_us_Clarity_feature__title">
//           How we think about work
//         </h2>
//       </div>

//       <div className="about_us_Clarity_feature__cards">
//         {/* Card 1 - Clarity */}
//         <div className="about_us_Clarity_feature__card about_us_Clarity_feature__card--clarity">
//           <div className="about_us_Clarity_feature__card_content">
//             <div className="about_us_Clarity_feature__icon_wrapper about_us_Clarity_feature__icon_wrapper--clarity">
//               <svg
//                 className="about_us_Clarity_feature__icon"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//               >
//                 <path d="M14 2v4a2 2 0 0 0 2 2h4" />
//                 <path d="M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" />
//                 <path d="m9 18-1.5-1.5" />
//                 <circle cx="5" cy="14" r="3" />
//               </svg>
//             </div>
//             <h3 className="about_us_Clarity_feature__card_title">
//               Clarity is a feature
//             </h3>
//             <p className="about_us_Clarity_feature__card_text">
//               If you have to hunt for information, the software has failed. We
//               believe every piece of data should have a clear, logical home that
//               requires zero guesswork.
//             </p>
//             <div className="about_us_Clarity_feature__underline about_us_Clarity_feature__underline--clarity"></div>
//           </div>
//           <div className="about_us_Clarity_feature__visual about_us_Clarity_feature__visual--clarity">
//             <div className="about_us_Clarity_feature__abstract_shapes about_us_Clarity_feature__abstract_shapes--clarity">
//               <div className="shape shape-1"></div>
//               <div className="shape shape-2"></div>
//               <div className="shape shape-3"></div>
//               <div className="shape shape-4"></div>
//               <div className="center-icon">
//                 <svg
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <path d="M14 2v4a2 2 0 0 0 2 2h4" />
//                   <path d="M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" />
//                   <path d="m9 18-1.5-1.5" />
//                   <circle cx="5" cy="14" r="3" />
//                 </svg>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Card 2 - Speed */}
//         <div className="about_us_Clarity_feature__card about_us_Clarity_feature__card--speed">
//           <div className="about_us_Clarity_feature__card_content">
//             <div className="about_us_Clarity_feature__icon_wrapper about_us_Clarity_feature__icon_wrapper--speed">
//               <svg
//                 className="about_us_Clarity_feature__icon"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//               >
//                 <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
//               </svg>
//             </div>
//             <h3 className="about_us_Clarity_feature__card_title">
//               Speed should feel calm
//             </h3>
//             <p className="about_us_Clarity_feature__card_text">
//               Fast shouldn't mean frantic. By removing clicks, reducing
//               screen-switching, and automating follow-ups, teams can move faster
//               while feeling more in control.
//             </p>
//             <div className="about_us_Clarity_feature__underline about_us_Clarity_feature__underline--speed"></div>
//           </div>
//           <div className="about_us_Clarity_feature__visual about_us_Clarity_feature__visual--speed">
//             <div className="about_us_Clarity_feature__radar_rings">
//               <div className="ring ring-1"></div>
//               <div className="ring ring-2"></div>
//               <div className="ring ring-3"></div>
//               <div className="ring ring-4"></div>
//               <div className="orb orb-1"></div>
//               <div className="orb orb-2"></div>
//               <div className="orb orb-3"></div>
//               <div className="center-zap">
//                 <svg
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
//                 </svg>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Card 3 - Systems */}
//         <div className="about_us_Clarity_feature__card about_us_Clarity_feature__card--systems">
//           <div className="about_us_Clarity_feature__card_content">
//             <div className="about_us_Clarity_feature__icon_wrapper about_us_Clarity_feature__icon_wrapper--systems">
//               <svg
//                 className="about_us_Clarity_feature__icon"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//               >
//                 <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
//                 <path d="M12 8v4" />
//                 <path d="M12 16h.01" />
//               </svg>
//             </div>
//             <h3 className="about_us_Clarity_feature__card_title">
//               Systems protect revenue
//             </h3>
//             <p className="about_us_Clarity_feature__card_text">
//               A dropped task isn't just an inconvenience; it's a risk to the
//               business. We build systems robust enough to ensure nothing slips
//               through the cracks.
//             </p>
//             <div className="about_us_Clarity_feature__underline about_us_Clarity_feature__underline--systems"></div>
//           </div>
//           <div className="about_us_Clarity_feature__visual about_us_Clarity_feature__visual--systems">
//             <div className="about_us_Clarity_feature__network">
//               <div className="node-group">
//                 <div className="node node-1"></div>
//                 <div className="node node-2"></div>
//                 <div className="node node-3"></div>
//                 <div className="node node-4"></div>
//                 <div className="node node-5"></div>
//                 <div className="node node-6"></div>
//               </div>
//               <div className="orbital-group">
//                 <div className="orbital orb-1"></div>
//                 <div className="orbital orb-2"></div>
//                 <div className="orbital orb-3"></div>
//                 <div className="orbital orb-4"></div>
//               </div>
//               <svg className="network-lines" viewBox="0 0 200 200">
//                 <line
//                   x1="100"
//                   y1="100"
//                   x2="50"
//                   y2="40"
//                   stroke="#10b981"
//                   strokeWidth="1.5"
//                   strokeDasharray="4 4"
//                 />
//                 <line
//                   x1="100"
//                   y1="100"
//                   x2="150"
//                   y2="50"
//                   stroke="#10b981"
//                   strokeWidth="1.5"
//                   strokeDasharray="4 4"
//                 />
//                 <line
//                   x1="100"
//                   y1="100"
//                   x2="140"
//                   y2="150"
//                   stroke="#10b981"
//                   strokeWidth="1.5"
//                   strokeDasharray="4 4"
//                 />
//                 <line
//                   x1="100"
//                   y1="100"
//                   x2="60"
//                   y2="160"
//                   stroke="#10b981"
//                   strokeWidth="1.5"
//                   strokeDasharray="4 4"
//                 />
//               </svg>
//               <div className="center-shield">
//                 <svg
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
//                   <path d="M12 8v4" />
//                   <path d="M12 16h.01" />
//                 </svg>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhatWeBelieve;

import React from "react";
import { motion } from "framer-motion";
import { FileSearch, Zap, ShieldAlert } from "lucide-react";
const WhatWeBelieve = () => {
  const principles = [
    {
      num: "01",
      title: "Clarity is a feature",
      desc: "If you have to hunt for information, the software has failed. We believe every piece of data should have a clear, logical home that requires zero guesswork.",
      icon: <FileSearch size={26} className="WhatWeBelieve_blue" />,
      lineClass: "WhatWeBelieve_line_blue",
      reverse: false,
      graphic: (
        <div className="WhatWeBelieve_graphic_container">
          <motion.div
            animate={{
              opacity: [0.4, 0.8, 0.4],
              scale: [1, 1.2, 1],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
            }}
            className="WhatWeBelieve_spotlight"
          />

          <div className="WhatWeBelieve_blocks">
            <motion.div
              initial={{ x: -80, y: -50, rotate: -20, opacity: 0 }}
              whileInView={{ x: 0, y: 0, rotate: 0, opacity: 1 }}
              transition={{ duration: 1 }}
              className="WhatWeBelieve_box box1"
            />

            <motion.div
              initial={{ x: 80, y: -40, rotate: 20, opacity: 0 }}
              whileInView={{ x: 0, y: 0, rotate: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.2 }}
              className="WhatWeBelieve_box box2"
            />

            <motion.div
              initial={{ x: -70, y: 60, rotate: -20, opacity: 0 }}
              whileInView={{ x: 0, y: 0, rotate: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.4 }}
              className="WhatWeBelieve_box box3"
            />

            <motion.div
              initial={{ x: 70, y: 50, rotate: 20, opacity: 0 }}
              whileInView={{ x: 0, y: 0, rotate: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.6 }}
              className="WhatWeBelieve_box box4"
            />

            <motion.div
              // initial={{ scale: 0 }}
              initial={{ x: 100, y: 60, scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{
                duration: 0.8,
                delay: 1,
                type: "spring",
              }}
              className="WhatWeBelieve_center_icon"
            >
              <FileSearch size={34} className="WhatWeBelieve_blue" />
            </motion.div>
          </div>
        </div>
      ),
    },

    {
      num: "02",
      title: "Speed should feel calm",
      desc: "Fast shouldn't mean frantic. By removing clicks, reducing screen-switching, and automating follow-ups, teams can move faster while feeling more in control.",
      icon: <Zap size={26} className="WhatWeBelieve_amber" />,
      lineClass: "WhatWeBelieve_line_amber",
      reverse: true,
      graphic: (
        <div className="WhatWeBelieve_graphic_container">
          {[1, 2, 3, 4].map((item) => (
            <motion.div
              key={item}
              animate={{
                scale: [1, 2.5, 1],
                opacity: [0.7, 0, 0.7],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                delay: item * 0.5,
              }}
              className="WhatWeBelieve_ripple"
            />
          ))}

          <motion.div
            animate={{
              y: [-20, 20, -20],
              rotate: [0, 360],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
            }}
            className="WhatWeBelieve_particle particle1"
          />

          <motion.div
            animate={{
              y: [20, -20, 20],
              rotate: [360, 0],
            }}
            transition={{
              duration: 9,
              repeat: Infinity,
            }}
            className="WhatWeBelieve_particle particle2"
          />

          <motion.div
            initial={{ scale: 0, rotate: -180 }}
            whileInView={{ scale: 1, rotate: 0 }}
            transition={{ duration: 1 }}
            className="WhatWeBelieve_center_icon"
          >
            <motion.div
              animate={{ rotate: 360 }}
              transition={{
                duration: 15,
                repeat: Infinity,
                ease: "linear",
              }}
            >
              <Zap size={38} className="WhatWeBelieve_amber" />
            </motion.div>
          </motion.div>
        </div>
      ),
    },

    {
      num: "03",
      title: "Systems protect revenue",
      desc: "A dropped task isn't just an inconvenience; it's a risk to the business. We build systems robust enough to ensure nothing slips through the cracks.",
      icon: <ShieldAlert size={26} className="WhatWeBelieve_green" />,
      lineClass: "WhatWeBelieve_line_green",
      reverse: false,
      graphic: (
        <div className="WhatWeBelieve_graphic_container">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{
              duration: 30,
              repeat: Infinity,
              ease: "linear",
            }}
            className="WhatWeBelieve_outer_ring"
          >
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div key={item} className="WhatWeBelieve_ring_box" />
            ))}
          </motion.div>

          <motion.div
            initial={{ scale: 0, rotate: -90 }}
            whileInView={{ scale: 1, rotate: 0 }}
            transition={{
              duration: 1,
              delay: 0.5,
              type: "spring",
            }}
            className="WhatWeBelieve_center_icon"
          >
            <ShieldAlert size={40} className="WhatWeBelieve_green" />
          </motion.div>
        </div>
      ),
    },
  ];

  return (
    <section className="WhatWeBelieve_main">
      <div className="WhatWeBelieve_container">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="WhatWeBelieve_heading_wrapper"
        >
          <span className="WhatWeBelieve_badge">Our Philosophy</span>

          <h2 className="WhatWeBelieve_heading">How we think about work</h2>
        </motion.div>

        <div className="WhatWeBelieve_cards">
          {principles.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className={`WhatWeBelieve_card ${
                item.reverse ? "WhatWeBelieve_reverse" : ""
              }`}
            >
              {/* Text */}
              <div className="WhatWeBelieve_content">
                <span className="WhatWeBelieve_big_number">{item.num}</span>

                <div className="WhatWeBelieve_icon_box">{item.icon}</div>

                <h3 className="WhatWeBelieve_title">{item.title}</h3>

                <p className="WhatWeBelieve_desc">{item.desc}</p>

                <div className={`WhatWeBelieve_line ${item.lineClass}`} />
              </div>

              {/* Graphic */}
              <div className="WhatWeBelieve_visual">{item.graphic}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeBelieve;
